var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.href ?? '#'}},[(_vm.type === 'app-widget-with-icon')?_c('app-widget-with-icon',{attrs:{"data":_vm.$props}}):(_vm.type === 'app-widget-without-icon')?_c('app-widget-without-icon',{attrs:{"data":_vm.$props}}):(_vm.type === 'app-widget-with-circle')?_c('app-widget-with-circle',{attrs:{"data":_vm.$props}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }